/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import EnvironmentModel from 'cio/models/environment';
import { PERMANENT_OBJECT_ATTRIBUTES, RESTRICTED_ATTRIBUTES } from 'cio/utils/attributes';
import {
  ObjectTypeIdentifierKey,
  isAttributeEnabledIdentifier,
  isObjectAttributeIdentifier,
} from 'cio/utils/identifiers';

interface AttributeTypeLabelArgs {
  environment: EnvironmentModel;
  attribute: string;
  ignoreIdentifiers?: boolean;
  isObject?: boolean;
  isRelationship?: boolean;
}

export default class AttributeTypeLabel extends Component<AttributeTypeLabelArgs> {
  get isObject() {
    return this.args.isObject ?? false;
  }

  get isRelationship() {
    return this.args.isRelationship ?? false;
  }

  get isIdentifier() {
    if (this.isObject) {
      return isObjectAttributeIdentifier(this.args.attribute);
    }
    if (this.isRelationship) {
      return (
        this.args.attribute === ObjectTypeIdentifierKey.ObjectTypeId ||
        isAttributeEnabledIdentifier(this.args.attribute, this.args.environment.identifiers)
      );
    }
    return isAttributeEnabledIdentifier(this.args.attribute, this.args.environment.identifiers);
  }

  get isReserved() {
    if (this.isObject) {
      return PERMANENT_OBJECT_ATTRIBUTES.includes(this.args.attribute);
    }
    return RESTRICTED_ATTRIBUTES.includes(this.args.attribute);
  }
}
